import { useEffect, useState } from "react";
import { CardHelpdesk } from "../Cards/CardHelpdesk";
import { useDispatch, useSelector } from "react-redux";
import { downloadFile, getAdminSolicitudes, getBitacora, getPrioridad, getReporteSolicitudes, getUserSolicitudes, setCasoSelecionado, setFechaIFin, setFechaInicial, setLoadingHD } from "../../slices";
import { format, subDays } from "date-fns";
import { useForm } from "react-hook-form";
import ButtonCustom from "../CustomButtom/ButtonCustom";
import Modal from "../modal/Modal";
import { toast } from "react-toastify";
import { TableDetails } from "./TableDetails";
import { HeaderDetails } from "./HeaderDetails";
import { offset } from "highcharts";

export const ResolverSolicitudes = () => {

  const dispatch = useDispatch(); 
  const { fini, ffin, rpcase, casoSeleccionado, casoNivelesSeleccionado, detallesCaso } = useSelector((state) => state.helpdesk);

  const [isOpenD, setIsOpenD] = useState(false);


  let first_name = ''
  let last_name = ''

  const {
      register,
      handleSubmit,
      setValue,
      formState: { errors },
    } = useForm({
      defaultValues: {
        fini: null,
        ffin: null,
      },
    });


    const onSubmit = async (data) => {
      try {
        dispatch(setFechaInicial(format(new Date(data.fini), "yyyy-MM-dd")));
        dispatch(setFechaIFin(format(new Date(data.ffin), "yyyy-MM-dd")));     
    
        await dispatch(getReporteSolicitudes({
          fini: fini, ffin: ffin
        }))
      } catch (error) {
        toast.error(error)
      }
       
    };
  

  const setDate = async () => {
      dispatch(setFechaInicial(format(subDays(new Date(Date.now()), 180), "yyyy-MM-dd")));
      dispatch(setFechaIFin(format(new Date(Date.now()), "yyyy-MM-dd")));
      setValue("fini", format(subDays(new Date(Date.now()), 180), "yyyy-MM-dd"));
      setValue("ffin", format(new Date(Date.now()), "yyyy-MM-dd"));
    };

  const getDataReporte = () => {
    try {
      setDate()
      dispatch(setLoadingHD(true));
      setTimeout(async () => {
        await dispatch(getUserSolicitudes({
          fini: fini, ffin: ffin
        }));       
        await dispatch(getReporteSolicitudes()) 
        await dispatch(getAdminSolicitudes())
        await dispatch(getPrioridad())        
      }, 2000);
      dispatch(setLoadingHD(false));      
    } catch (error) {
      toast.error(error.msg);
      dispatch(setLoadingHD(false));
    }
  }

  const modalDHide = () => {
    setIsOpenD(false);    
  }
  const getDetalles = async (value, infocase) => {
      try {
        dispatch(setLoadingHD(true));
        dispatch(setCasoSelecionado(infocase))
        dispatch(getBitacora(value, infocase.id_hd2_organizacion_niveles))
        setIsOpenD(true);
      } catch (error) {
        toast.error(error.msg);
        dispatch(setLoadingHD(false));
      }
  }

  const handleDownload = async (e) => {
    await dispatch(downloadFile(e))
  }

  useEffect(() => {
    getDataReporte()
   
    // eslint-disable-next-line
  }, [])
  
  if(detallesCaso.length > 0)
  {

    first_name = detallesCaso[0].first_name
    last_name = detallesCaso[0].last_name
    
  }
    

  return (
    <>
      <Modal
        handleClose={modalDHide} 
        isOpen={isOpenD} 
        header={ `Seguimiento de Caso ${casoSeleccionado.id}`} 
        invoiceNum={' '}
        size='modal-xl'
      >
        <HeaderDetails 
          tituloprincipal={"DETALLES CASO"} 
          area={casoSeleccionado.desc_area} 
          nivel={casoNivelesSeleccionado.replaceAll(',', ' -> ')} 
          prioridad={casoSeleccionado.prioridad_name}
          titulo={casoSeleccionado.title} 
          descripcion={casoSeleccionado.description}
          usuarioresponsable={first_name + ' ' + last_name}
        />
        <div className="row">
          <div className="col-md-12 col-lg-12"> 
          <hr />
          <h2 className="font-weight-bold">HISTORICO DEL CASO</h2>             
          <TableDetails data={detallesCaso} onClick={handleDownload}/>
        </div>
      </div>
      </Modal> 
    <div className="col-md-12">
      <h2>Resolver las solicitudes</h2>
      <hr className="my-1" />
      <div>
        
      <div className="px-1 py-2 mt-2 bg-white border rounded">
        <div className="col-12 mb-2">
            <form className="row col-12 col-md-12" onSubmit={handleSubmit(onSubmit)}>
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                <div className="form-group">
                  <label>Fecha inicial</label>
                  <input
                    type="date"
                    className="form-control"
                    {...register("fini")}
                  />
                </div>
                {errors.fini && (<p className='text-danger mb-0'>{errors ? errors.fini?.message : ''}</p>)}
              </div>
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                <div className="form-group">
                  <label>Fecha final</label>
                  <input
                    type="date"
                    className="form-control"
                    {...register("ffin")}
                  />
                </div>
                {errors.ffin && (<p className='text-danger mb-0'>{errors ? errors.ffin?.message : ''}</p>)}
              </div>
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2 pt-4 mb-2">
                <ButtonCustom classnames="btn btn-danger btn-block font-weight-bold mt-2">
                  Buscar &nbsp;<i className="fa fa-search"></i>
                </ButtonCustom>
              </div>
              <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2 pt-4">
                <ButtonCustom
                  type="button"
                  classnames="btn btn-secondary btn-block font-weight-bold mt-2">
                  Limpiar &nbsp;<i className="fa fa-trash"></i>
                </ButtonCustom>
              </div>
            </form>
          </div>
          <div className="col-md-12">
            <div className="row">
              {rpcase.length > 0 ? (
                rpcase?.map((r, index) => (
                  <CardHelpdesk data={r} key={index}  getDetalles={getDetalles}/>
                ))
              ): (
                <p>No hay datos</p>
              )}    
            </div>
          </div>
      </div>
       
      </div>
    </div>
    </>
  );
};
